<template>
            <v-card>
                <v-card-title v-if="!readonly">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded @click="addItem"><v-icon>mdi-plus</v-icon> Toevoegen</v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row v-for="field in activeItems" :key="field.index">
                        <v-col>
                            <eod-text-field :rules="nameRules" placeholder="Veldnaam" v-model="value[field.index].name" :disabled="readonly"></eod-text-field>
                        </v-col>
                        <v-col sm="auto">
                            <v-switch
                            :disabled="readonly"
                                v-model="value[field.index].isActive"
                                color="success"
                                :true-value="true"
                                :false-value="false"
                                hide-details
                                inset
                                class="mt-0"
                            ></v-switch>
                        </v-col>
                        <v-col sm="auto" v-if="!readonly">
                            <v-dialog v-model="deleteDialog[field.index]" persistent max-width="360">
                                <template v-slot:activator="{ on: dialog, attrs }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on: tooltip }">
                                        <v-btn class="error--text" icon v-bind="attrs" v-on="{ ...tooltip, ...dialog}">
                                            <v-icon>mdi-trash-can-outline</v-icon>
                                        </v-btn>
                                        </template>
                                        Verwijderen
                                    </v-tooltip>
                                </template>
                                <v-card>
                                    <v-card-title>
                                    <v-avatar color="error" size="40" class="elevation-3 mr-4">
                                <v-icon dark>
                                mdi-trash-can-outline
                                </v-icon>
                            </v-avatar><span class="headline">Verwijderen?</span>
                            </v-card-title>
                                    <v-card-text>Weet u zeker dat u '{{field.name}}' wilt verwijderen?</v-card-text>
                                    <v-card-actions class="grey lighten-3 py-3 px-3">
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="hideDeleteDialog(field.index)" rounded>Annuleren</v-btn>
                                    <v-btn color="error" depressed rounded @click="deleteItem(field)">
                                        <v-icon left>mdi-trash-can-outline</v-icon> Verwijderen
                                    </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-col>
                    </v-row>
                </v-card-text>

</v-card>
</template>

<script>
import eodColumnActions from './columns/eod-column-actions.vue';

export default {
  name: 'Fields',
  components: {
      'eod-actions-column': eodColumnActions
  },
  props: {
      value: Array,
      readonly: {
            type: Boolean,
            default: false
        }
  },
  data(){
      return {
        nameRules: [
            v => !!v || 'Naam is verplicht',
        ],
        deleteDialog: []
      }
  },
  computed: {
      activeItems(){
          let items = [];
          if(this.value){
            for (let i = 0; i < this.value.length; i++) {
                let item = Object.assign({}, this.value[i]);
                item.index = i;
                items.push(item);
            }
          }
          
          return items;
      }
  },
  methods: {
      hideDeleteDialog(index){
          this.deleteDialog[index] = false;
          this.$forceUpdate();
      },
      deleteItem(item){
        this.value.splice(item.index, 1);
        this.deleteDialog[item.index] = false;
        this.$emit('input', this.value);
        this.$emit('delete', item.index);
      },
      addItem(){
          if (!this.value) {
              this.value = [];
          }

          this.value.push({
              name: '',
              isActive: true
          });

          this.$emit('input', this.value);
          this.$emit('add', this.value.length-1);
      },
  }
}
</script>
